'use client'

import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

import { urlAddSearchParams } from '../../url-handling'

type SearchParamsReader = {
  get: (name: string) => string | null
}

export const urlWithSearchAttribution = (
  url: string,
  searchParams: SearchParamsReader,
): string => {
  const searchAttributionParams: Record<string, string> = {}

  for (const paramName of ['query', 'queryID']) {
    const value = searchParams.get(paramName)

    if (value) {
      searchAttributionParams[paramName] = value
    }
  }

  return urlAddSearchParams(url, searchAttributionParams)
}

export const useUrlWithSearchAttribution = (url: string): string => {
  const searchParams = useSearchParams()

  return useMemo(
    () => urlWithSearchAttribution(url, searchParams),
    [searchParams, url],
  )
}
